module.exports = __webpack_public_path__ + "static/media/af.ddee87a8.svg";